var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M39.45577,34.58007l-7.79236-7.791c-.35265-.35117-.83051-.5477-1.32823-.54628h-1.27436c5.52122-7.0738,4.2616-17.2833-2.81344-22.80355C19.17235-2.08101,8.96107-.82161,3.43985,6.25219-2.08137,13.32599-.82176,23.53549,6.25328,29.05574c5.87597,4.58469,14.11814,4.58469,19.99411,0v1.27413c-.00143,.49763,.19514,.9754,.54637,1.328l7.79236,7.791c.72748,.73173,1.91051,.73528,2.64237,.00793,.00265-.00263,.00529-.00528,.00793-.00793l2.21166-2.21127c.73288-.73308,.73632-1.92022,.00769-2.65753Zm-23.21395-8.33882c-5.52507,0-10.00402-4.47817-10.00402-10.00227S10.71676,6.23672,16.24183,6.23672s10.00402,4.47817,10.00402,10.00227-4.47895,10.00227-10.00402,10.00227Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3e667140038b5b72aa278ce02eeb2b6b.svg";
export { ForwardRef as ReactComponent };